import { FormatMoneyLocal } from 'eco-design-micro/price/FormatMoneyLocal';
import { createPortal } from 'react-dom';
import InstallationPopup from '../InstallationPopup';
import FeePopup from '../FeePopup';
import Popup from '../Popup';
import FeaturePopup from '../FeaturePopup';
import css from './index.module.scss';
import EcoCredits from './Icons/EcoCredits';
import Paidy from './Icons/Paidy';
import QuoteWinFloat from './QuoteWinFloat';
import QuoteWin from './QuoteWin';
import VoucherWin from './VoucherWin';
import Installation from './Icons/Installation';
import USInstallation from './Icons/USInstallation';
import USArea from './Icons/USArea';
import USIRA from './Icons/USIRA';
import USSupport from './Icons/USSupport';
import USHelp from './Icons/USHelp';
import USConsulting from './Icons/USConsulting';
import PostcodeQueryPopUp from '@elem/compPage/DeltaProUltra/Launch/PostcodeQueryPopUp';
import CastCardPopUp from '../CastCardPopUp';
import OptionsPopUp from '../OptionsPopUp';
import ApplyRebstesPopUp from '../ApplyRebstesPopUp';
// import Spreed from './Icons/Spreed';
// import Consulting from './Icons/Consulting';
// import Credits from './Icons/Credits';
import IRA from './Icons/IRA';
import Coupon from './Icons/Coupon';
import News from './Icons/News';
import { getSolarRecommand } from '@/service/solar-calculator';
import { useGlobal } from '@/utils/useGlobal';

const ICON_EMAIL = () => (
    <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Group">
            <path
                id="Rectangle"
                d="M17.1998 0.799805H2.7998C1.69524 0.799805 0.799805 1.69524 0.799805 2.7998V14.1998C0.799805 15.3044 1.69524 16.1998 2.7998 16.1998H17.1998C18.3044 16.1998 19.1998 15.3044 19.1998 14.1998V2.7998C19.1998 1.69524 18.3044 0.799805 17.1998 0.799805Z"
                stroke="#3F68E0"
                strokeWidth="1.6"
            />
            <path id="Path-26" d="M1 1.5L8.72324 8.3651C9.45856 9.01872 10.56 9.04049 11.3206 8.41643L19 2.11538" stroke="#3F68E0" strokeWidth="1.6" />
        </g>
    </svg>
);

const ICON_PHONE = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            d="M20.1685 16.979L16.6412 13.4515C16.4283 13.2393 16.14 13.12 15.8395 13.12C15.5389 13.12 15.2506 13.2393 15.0378 13.4515L14.2361 14.2532C13.7826 14.7067 12.3141 14.2554 11.0294 12.9706C9.74473 11.6857 9.29251 10.218 9.74672 9.76391L10.5484 8.96222C10.7607 8.74942 10.8799 8.46111 10.8799 8.16053C10.8799 7.85994 10.7607 7.57163 10.5484 7.35883L7.02091 3.83149C6.80813 3.61921 6.51985 3.5 6.21929 3.5C5.91873 3.5 5.63044 3.61921 5.41766 3.83149L4.61596 4.63318C4.02358 5.22556 3.66277 6.00472 3.5433 6.94913C3.43247 7.82508 3.53465 8.80746 3.84686 9.8685C4.47311 11.9999 5.88547 14.2408 7.82261 16.1773C9.75975 18.1139 12.0002 19.5268 14.1309 20.1531C14.9159 20.3839 15.6575 20.5 16.3448 20.5C16.5808 20.5004 16.8167 20.4859 17.0509 20.4566C17.9953 20.3372 18.7744 19.9763 19.3668 19.384L20.1685 18.5823C20.3808 18.3695 20.5 18.0812 20.5 17.7806C20.5 17.4801 20.3808 17.1918 20.1685 16.979Z"
            stroke="#3F68E0"
            strokeWidth="1.6"
        />
    </svg>
);

const ICON_TOOL = () => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_11451_15762)">
            <path
                d="M13.3233 4.50973C15.17 6.35643 15.17 9.35055 13.3233 11.1973C12.7586 11.762 12.0865 12.154 11.3728 12.3734V17.8023L11.3728 24.3978L8.58631 24.3978V12.3734C7.87259 12.154 7.20052 11.762 6.63578 11.1973C4.78907 9.35055 4.78908 6.35643 6.63578 4.50973C7.20052 3.94499 7.87257 3.55295 8.58631 3.33361L8.58631 7.57485L11.3728 7.57485L11.3728 3.33361C12.0865 3.55296 12.7586 3.94499 13.3233 4.50973Z"
                stroke="#85A3FF"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M17.5 14H22.1667V24.5H17.5V14Z" stroke="#85A3FF" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M18.4333 7.7V14H21.2333V7.7L22.1667 6.3L21.2333 3.5H18.4333L17.5 6.3L18.4333 7.7Z"
                stroke="#85A3FF"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_11451_15762">
                <rect width="28" height="28" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default function ProductBriefGuideInfo({ info, langKey, popup, callBuy, freeQuote, freeQuoteBack, feePop, callFeePop }: any) {
    const { useLang, useRouter, useEffect, useState, gtm, Link, getSystemTime } = useGlobal();
    const { locale, pathname, query } = useRouter();
    const { t } = useLang(langKey);
    const { t: s } = useLang('shared.product.info');
    const { t: m } = useLang('shared.product.menu');
    const { subtitle = '', title, desc, textArr, productId, variantId, tip, priceTip, tel } = info;
    const [shopify, setShopify] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [isClient, setIsClient] = useState(false);
    const isUSCA = ['us', 'ca', 'br'].includes(locale); // 北美
    const isPathDailyUse = pathname === '/delta-pro-ultra-daily-use';
    const hideQuoteWinFloatInUs =
        locale === 'us' &&
        ['/delta-pro-portable-power-station', '/delta-pro-3-portable-power-station', '/delta-pro-ultra'].includes(pathname);
    const [popupContent, setPopupContent] = useState();
    const [showFeaturePopup, setShowFeaturePopup] = useState(false);
    const [showInstallatioPopup, setShowInstallationPopup] = useState(false);
    const [showFeePopup, setShowFeePopup] = useState(false);
    const [showPostcodeQueryPopUp, setShowPostcodeQueryPopUp] = useState(false);
    const [featuresBWin, setFeaturesBWin] = useState('');
    const [showCastCard, setShowCastCard] = useState(false);
    const [showOptionsCard, setShowOptionsCard] = useState(false);
    const [openApplyRebstes, setOpenApplyRebstes] = useState(false);
    const ICON_MAP: any = {
        us: [
            {
                icon: <USInstallation />,
                text: 'icon_free',
                details: 'Starting at $484/mo or 0% APR with ',
            },
            // {
            //     icon: <Spreed />,
            //     text: 'icon_year5',
            // },
            {
                icon: <USIRA />,
                text: 'icon_tax_refund',
                details:
                    'The Federal Solar Tax Credit, or Residential Clean Energy Credit, offers a 30% financial incentive for US taxpayers installing residential solar energy systems, including battery storage technology with a capacity above 3kWh. This credit helps offset upfront costs, making both solar and storage solutions more accessible for homeowners.',
            },
            {
                icon: <USConsulting />,
                text: 'icon_service',
                details: locale === 'us',
            },
            // {
            //     icon: <Credits />,
            //     text: 'icon_eco_credits',
            //     details: `3 x EcoCredits vaild period: January 9, 2024, 00:00 (EST) to February 9, 2025, 23:59 (EST).\nMembers can earn triple EcoCredits when purchasing designated products. Include purchases of an EcoFlow DELTA Pro Ultra Inverter, EcoFlow DELTA Pro Ultra Battery, EcoFlow Smart Home Panel 2, EcoFlow DELTA Pro Ultra (Inverter+Battery), EcoFlow DELTA Pro Ultra+EcoFlow Smart Home Panel 2, 2 × EcoFlow DELTA Pro Ultra + EcoFlow Smart Home Panel 2 made on the EcoFlow ${String(
            //         locale,
            //     ).toUpperCase()} Online Store `,
            // },
            // {
            //     icon: <Fee />,
            //     text: 'icon_installation_fee',
            //     details:
            //         'The Federal Solar Tax Credit, or Residential Clean Energy Credit, offers a 30% financial incentive for US taxpayers installing residential solar energy systems, including battery storage technology with a capacity above 3KWh. This credit helps offset upfront costs, making both solar and storage solutions more accessible for homeowners.',
            // },
            {
                icon: <USArea />,
                text: 'icon_area',
                details: locale === 'us',
            },
            {
                icon: <USHelp />,
                text: 'icon_help',
                details: locale === 'us',
            },
            {
                icon: <USSupport />,
                text: 'icon_support',
                details: locale === 'us',
            },
        ],
        ca: [
            // {
            //     icon: <EcoCredits />,
            //     text: 'icon_eco_credits',
            //     details: `3 x EcoCredits vaild period: January 9, 2024, 00:00 (EST) to February 9, 2025, 23:59 (EST).\nMembers can earn triple EcoCredits when purchasing designated products. Include purchases of an EcoFlow DELTA Pro Ultra Inverter, EcoFlow DELTA Pro Ultra Battery, EcoFlow Smart Home Panel 2, EcoFlow DELTA Pro Ultra (Inverter+Battery), EcoFlow DELTA Pro Ultra+EcoFlow Smart Home Panel 2, 2 × EcoFlow DELTA Pro Ultra + EcoFlow Smart Home Panel 2 made on the EcoFlow ${String(
            //         locale,
            //     ).toUpperCase()} Online Store `,
            // },
            {
                icon: <USHelp />,
                text: 'icon_help',
                details: true,
            },
            {
                icon: <Coupon />,
                text: 'icon_cost',
                details: true,
            },
            {
                icon: <USInstallation />,
                text: 'icon_options',
                details: true,
            },
            {
                icon: <News />,
                text: 'icon_rebates',
                details: true,
            },
            {
                icon: <USSupport />,
                text: 'icon_support',
                details: true,
            },
            {
                icon: <USConsulting />,
                text: 'icon_free',
                details: true,
            },
        ],
        jp: [
            {
                icon: <EcoCredits />,
                text: 'icon_eco_credits',
                details: `・2/18（日）までポイント5倍\n・対象商品は、公式オンラインストア（`,
            },
            {
                icon: <Paidy />,
                text: 'icon_installment',
                details: `3・6・12回あと払いが原則的にご利用いただけます。`,
            },
        ],
    };

    // 去掉3倍积分，需要定时生效
    const resetIconMap = () => {
        const tempTime = new Date('2025/01/01 16:00:00 GMT+8').getTime();
        let currentTime = getSystemTime();
        if (query._timer) {
            currentTime = new Date(`${query._timer} GMT+8`).getTime();
        }
        if (currentTime > tempTime) {
            // 去掉3倍积分的标签
            // ICON_MAP['us'].splice(3, 1);
            // ICON_MAP['ca'].splice(0, 1);
        }
    };

    resetIconMap();

    const features: any[] = info.features ?? ICON_MAP[locale];

    const handleOpenQuote = () => {
        setOpenQuoteFlag(true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'click_get_a_quote',
            product_name: t(desc),
            position: 'Introduction',
            option_name: 'Get a Free Quote',
        });
    };

    const handleClickBuy = () => {
        callBuy();
        gtm.push({
            event: 'uaEvent',
            event_name: 'click_anchor',
            position: m('tab_bundles'),
            button_name: s('buy_now'),
        });
    };

    const handleOpenFeaturePopup = (item: any) => {
        if (item?.details && locale !== 'ca') {
            if (item?.text === 'icon_service') {
                if (item.href) {
                    window.open(item.href, '_blank');
                    return;
                }
                setShowInstallationPopup(true);
            } else if (item?.text === 'icon_installation_fee') {
                setShowFeePopup(true);
            } else if (item?.text === 'icon_area') {
                setShowPostcodeQueryPopUp(true);
            } else if (item?.text === 'icon_support') {
                openDailyFeaturesBWin('daily-features-b-win-id4');
            } else if (item?.text === 'icon_help') {
                window.open('https://www.ecoflow.com/us/calculators/delta-pro-ultra', '_blank');
            } else {
                setPopupContent({ text: item.text, details: item.details });
                setShowFeaturePopup(true);
            }
        } else if (item?.details && locale === 'ca') {
            if (item?.text === 'icon_help') {
                window.open(`/${locale}/calculators/delta-pro-ultra`, '_target');
            } else if (item?.text === 'icon_cost') {
                setShowCastCard(true);
            } else if (item?.text === 'icon_options') {
                setShowOptionsCard(true);
            } else if (item?.text === 'icon_rebates') {
                setOpenApplyRebstes(true);
            } else if (item?.text === 'icon_support') {
                openDailyFeaturesBWin('daily-features-b-win-id4');
            } else if (item?.text === 'icon_free') {
                handleOpenQuote();
            }
        }
    };

    useEffect(() => {
        setIsClient(true);
        const tempObj: any = {};
        const getAsynItem = async (productId: string, variantId: string) => {
            return await new Promise(async (resolve, reject) => {
                try {
                    const res = await getSolarRecommand({ productId, variantId }, locale);
                    if (res?.code === '0') {
                        tempObj.discountPrice = res?.data?.price;
                        tempObj.originalPrice = res?.data?.compareAtPrice || res?.data?.price;
                        tempObj.inventory = res?.data?.inventoryQuantity ?? undefined;
                        // tempArr[k].inventory = 1;
                        tempObj.link_buy = `https://${locale}.ecoflow.com/cart/${variantId}:1?channel=buy_button`;
                        setShopify(tempObj);
                        return resolve(res);
                    } else {
                        console.error(res?.message);
                        return reject(res?.message);
                    }
                } catch (e) {
                    console.error(e);
                    return reject(e);
                }
            });
        };
        if (productId && variantId) {
            getAsynItem(productId, variantId);
        }
    }, []);

    // 膨胀券
    const [openVoucherFlag, setOpenVoucherFlag] = useState(false);
    const voucherCallback = (type: string) => {
        if (type === 'close') {
            setOpenVoucherFlag(false);
        }
    };
    // 表单收集
    const [openQuoteFlag, setOpenQuoteFlag] = useState(freeQuote || false);
    const quoteCallback = (type: string) => {
        if (locale === 'jp') {
            freeQuoteBack(true);
        }
        if (type === 'close') {
            setOpenQuoteFlag(false);
            freeQuoteBack(false);
        } else if (type === 'open') {
            setOpenQuoteFlag(true);
        }
    };

    useEffect(() => {
        setOpenQuoteFlag(freeQuote);
    }, [freeQuote]);

    useEffect(() => {
        setShowFeePopup(feePop);
    }, [feePop]);

    useEffect(() => {
        callFeePop && callFeePop(showFeePopup);
    }, [showFeePopup]);

    // 打开弹窗 safari  低版本（赛群的mac笔记本） => 不支持dialog
    const openDailyFeaturesBWin = (id: string) => {
        // const elem: any = document.querySelector(`#${id}`);
        // // console.log(11, id, elem);
        // if (elem) {
        //     elem.showModal();
        // }
        setFeaturesBWin(id);
    };
    // 关闭弹窗
    const closeDailyFeaturesBWin = () => {
        // const elems: any = document.querySelectorAll('.daily-features-b-win');
        // if (elems && elems.length) {
        //     for (let i = 0; i < elems.length; i++) {
        //         elems[i].close();
        //     }
        // }
        setFeaturesBWin('');
    };

    useEffect(() => {
        console.log('featuresBWin: ', featuresBWin);
    }, [featuresBWin]);

    return (
        <section className={`product-brief-guide-info ${css['product-brief-guide-info']}`}>
            <div className="info-detail">
                {subtitle && <p className="subtitle">{t(subtitle)}</p>}
                <h2 className="title">{t(title)}</h2>
                <p className="desc">
                    {t.rich(desc, {
                        n: (text: any) => <span className="no-wrap">{text}</span>,
                    })}
                </p>
                <ul className="text-lists">
                    {textArr?.map((text: any, k: number) => (
                        <li className="text-list" key={k}>
                            {t.rich(text, {
                                sup: (text: any) => <sup className="sup">{text}</sup>,
                                l: (text: any) => (
                                    <a
                                        className="link"
                                        onClick={() => {
                                            if (locale === 'ca') {
                                                handleOpenFeaturePopup(features[3]);
                                            }
                                        }}
                                    >
                                        {text}
                                    </a>
                                ),
                            })}
                        </li>
                    ))}
                </ul>
            </div>
            <div className="info-shopify">
                {!isPathDailyUse && (
                    <div className="price-box">
                        <h2 className="shopify-price">{FormatMoneyLocal(shopify?.discountPrice, locale)}</h2>
                        {shopify?.originalPrice !== shopify?.discountPrice && (
                            <span className="original-price">{FormatMoneyLocal(shopify?.originalPrice, locale)}</span>
                        )}
                    </div>
                )}
                {priceTip && <p className="price-tip">{t(priceTip)}</p>}
                {!!features && !isPathDailyUse && features?.length > 0 && (
                    <ul className="shopify-features">
                        {features?.map((item: any, k: number) => (
                            <li className="feature" key={k}>
                                <span className="feature-icon">{item?.icon}</span>
                                <p
                                    className={`feature-text ${item?.text === 'icon_service' ? 'yellow' : ''} ${item?.details ? 'link' : ''}`}
                                    onClick={() => handleOpenFeaturePopup(item)}
                                >
                                    {s.rich(item.text, {
                                        a: (text: string) => (
                                            <a
                                                href={'https://blog.ecoflow.com/us/guide-to-the-federal-solar-tax-credit/'}
                                                target={'_blank'}
                                                className="feature-link"
                                                rel="noreferrer"
                                            >
                                                {text}
                                            </a>
                                        ),
                                    })}
                                </p>
                            </li>
                        ))}
                    </ul>
                )}
                {isUSCA && !isPathDailyUse && (
                    <button className="buy-now" id="info-header-buy-now" onClick={handleClickBuy}>
                        {s('buy_now')}
                    </button>
                )}
                {locale === 'us' && !isPathDailyUse && (
                    // <Link
                    //     className="dpu-calculator"
                    //     href="/calculators/delta-pro-ultra"
                    //     target="_blank"
                    //     dataLayer={{
                    //         event: 'uaEvent',
                    //         event_name: 'calculator_entry',
                    //         button_name: 'Help Me Choose',
                    //     }}
                    // >
                    //     {'Help Me Choose'}
                    // </Link>
                    <button
                        className="dpu-calculator"
                        onClick={() => {
                            quoteCallback('open');
                        }}
                    >
                        {'Get a Free Quote'}
                    </button>
                )}
                {tel && (
                    <div className="tel">
                        <USSupport />
                        <a className="tel-text" href={`tel:${t(tel)}`}>
                            {t(tel)}
                        </a>
                    </div>
                )}
                {isPathDailyUse && locale === 'us' && (
                    <>
                        {isClient &&
                            featuresBWin === 'daily-features-b-win-id1' &&
                            createPortal(
                                <div className={`daily-features-b-win ${css['daily-features-b-win']}`} id="daily-features-b-win-id1">
                                    <div className="daily-features-b-win-out">
                                        <div className="daily-features-b-win-in">
                                            <div className="daily-features-b-win-title">30% IRA tax refund</div>
                                            <div className="daily-features-b-win-desc">
                                                The Federal Solar Tax Credit, or Residential Clean Energy Credit, offers a 30% financial incentive for US
                                                taxpayers installing residential solar energy systems, including battery storage technology with a capacity
                                                above 3kWh. This credit helps offset upfront costs, making both solar and storage solutions more accessible for
                                                homeowners.
                                            </div>
                                            <svg
                                                className="daily-features-b-win-close"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                onClick={closeDailyFeaturesBWin}
                                            >
                                                <path d="M6 5L19 18M19 5L6 18" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>,
                                document.body,
                            )}
                        {isClient &&
                            featuresBWin === 'daily-features-b-win-id2' &&
                            createPortal(
                                <div className={`daily-features-b-win ${css['daily-features-b-win']}`} id="daily-features-b-win-id2">
                                    <div className="daily-features-b-win-out">
                                        <div className="daily-features-b-win-in">
                                            <div className="daily-features-b-win-title">Pay 12 interest-free installments</div>
                                            <div className="daily-features-b-win-desc">0% APR with [Affirm]</div>
                                            <svg
                                                className="daily-features-b-win-close"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                onClick={closeDailyFeaturesBWin}
                                            >
                                                <path d="M6 5L19 18M19 5L6 18" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>,
                                document.body,
                            )}
                        {isClient &&
                            featuresBWin === 'daily-features-b-win-id3' &&
                            createPortal(
                                <div className={`daily-features-b-win ${css['daily-features-b-win']}`} id="daily-features-b-win-id3">
                                    <div className="daily-features-b-win-out">
                                        <div className="daily-features-b-win-in">
                                            <div className="daily-features-b-win-title">Professional installation team</div>
                                            <div className="daily-features-b-win-desc">
                                                Our installation experts will install your EcoFlow DELTA Pro Ultra system in a single day.
                                            </div>
                                            <svg
                                                className="daily-features-b-win-close"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                onClick={closeDailyFeaturesBWin}
                                            >
                                                <path d="M6 5L19 18M19 5L6 18" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>,
                                document.body,
                            )}
                        <div className="daily-use-line-a">
                            <span className="a-ms1">Prices Start from</span>
                            <span className="a-ms2">$6000+</span>
                        </div>
                        <div className="buy-now daily-use-buy" onClick={handleOpenQuote}>
                            <span className="quote-text">{'Get a Free Quote'}</span>
                        </div>
                        {/* {locale === 'us' && (
                            <Link
                                className="dpu-calculator"
                                href="/calculators/delta-pro-ultra"
                                target="_blank"
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'calculator_entry',
                                    button_name: 'Help Me Choose',
                                }}
                            >
                                {'Help Me Choose'}
                            </Link>
                        )} */}
                        <ul className="daily-features-b">
                            <li
                                className="daily-features-b-item daily-features-b-item-pointer"
                                onClick={() => openDailyFeaturesBWin('daily-features-b-win-id1')}
                            >
                                <IRA />
                                30% IRA tax refund
                            </li>
                            <li
                                className="daily-features-b-item daily-features-b-item-pointer"
                                onClick={() => {
                                    openDailyFeaturesBWin('daily-features-b-win-id2');
                                }}
                            >
                                <Installation />
                                Pay 12 interest-free installments
                            </li>
                            <li
                                className="daily-features-b-item daily-features-b-item-pointer"
                                onClick={() => {
                                    openDailyFeaturesBWin('daily-features-b-win-id3');
                                }}
                            >
                                <ICON_TOOL />
                                Professional installation team
                            </li>
                            <li
                                className="daily-features-b-item daily-features-b-item-pointer"
                                onClick={() => {
                                    openDailyFeaturesBWin('daily-features-b-win-id4');
                                }}
                            >
                                <ICON_PHONE />
                                Customer Support Hotline
                            </li>
                        </ul>
                    </>
                )}
                {(locale === 'us' || locale === 'ca') &&
                    isClient &&
                    featuresBWin === 'daily-features-b-win-id4' &&
                    createPortal(
                        <div className={`daily-features-b-win ${css['daily-features-b-win']}`} id="daily-features-b-win-id4">
                            <div className="daily-features-b-win-out">
                                <div className="daily-features-b-win-in">
                                    <div className="daily-features-b-win-title">Customer Support Hotline</div>
                                    <div className="daily-features-b-win-desc">
                                        Call us at<a href="tel:+12318887164"> +1 231-888-7164 </a>with any pre-order or after-sale questions.
                                    </div>
                                    <svg
                                        className="daily-features-b-win-close"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        onClick={closeDailyFeaturesBWin}
                                    >
                                        <path d="M6 5L19 18M19 5L6 18" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                            </div>
                        </div>,
                        document.body,
                    )}
            </div>

            {openVoucherFlag && isUSCA && <VoucherWin callback={voucherCallback} />}
            {isClient && ['jp', 'us', 'ca'].includes(locale) && !hideQuoteWinFloatInUs && <QuoteWinFloat callback={quoteCallback} desc={t(desc)} />}
            {openQuoteFlag && ['us', 'ca'].includes(locale) && <QuoteWin callback={quoteCallback} className={`${isPathDailyUse ? ' win-is-DailyUse' : ''}`} />}
            {['jp'].includes(locale) && (
                <>
                    <div className="support-msga">
                        DELTA Pro UltraおよびPower Switch Kitに関する詳しい技術情報や導入にかかる費用等について相談したい方は、
                        <a href="mailto:EcoFlow.Ultra@ecoflow.com">EcoFlow.Ultra@ecoflow.com</a>
                        までお気軽にご連絡ください。
                        <br />
                        DELTA Pro Ultra+Power Switch Kitは、札幌版次世代住宅補助金制度の対象製品になりました。最大220万円の補助金が申請可能です。詳しくは
                        <a href="https://www.city.sapporo.jp/toshi/jutaku/10shien/zisedai/zisedai.html" target="_blank" rel="noreferrer">
                            こちら
                        </a>
                    </div>
                    <div className="support-tel-email">
                        <a href="mailto:support.jp@ecoflow.com">
                            <ICON_EMAIL />
                            support.jp@ecoflow.com
                        </a>
                        <a href="tel:050-3090-2966">
                            <ICON_PHONE />
                            050-3090-2966（日本語のみ）
                        </a>
                    </div>
                    <button className="buy-now" onClick={handleClickBuy}>
                        {s('buy_now')}
                    </button>
                </>
            )}
            {tip && <p className="info-tip">{t(tip)}</p>}
            {isClient && createPortal(<Popup items={popup} langKey={langKey} show={showPopup} callback={() => setShowPopup(false)} />, document.body)}
            {isClient &&
                createPortal(<FeaturePopup content={popupContent} show={showFeaturePopup} callback={() => setShowFeaturePopup(false)} />, document.body)}
            {isClient && showInstallatioPopup && createPortal(<InstallationPopup callInstallation={() => setShowInstallationPopup(false)} />, document.body)}
            {isClient && showFeePopup && createPortal(<FeePopup callInstallation={() => setShowFeePopup(false)} />, document.body)}
            {isClient &&
                showPostcodeQueryPopUp &&
                createPortal(
                    <PostcodeQueryPopUp
                        callback={() => {
                            setShowPostcodeQueryPopUp(false);
                        }}
                    />,
                    document.body,
                )}
            {isClient &&
                showCastCard &&
                createPortal(
                    <CastCardPopUp
                        callback={() => {
                            setShowCastCard(false);
                        }}
                    />,
                    document.body,
                )}
            {isClient &&
                showOptionsCard &&
                createPortal(
                    <OptionsPopUp
                        callback={() => {
                            setShowOptionsCard(false);
                        }}
                    />,
                    document.body,
                )}
            {isClient &&
                openApplyRebstes &&
                createPortal(
                    <ApplyRebstesPopUp
                        callback={() => {
                            setOpenApplyRebstes(false);
                        }}
                    />,
                    document.body,
                )}
        </section>
    );
}
